import { Component } from 'react';
import {connect} from 'react-redux';
import {Container} from 'react-bootstrap';
import {Form} from 'forms/rrf';
import {toast} from 'react-toastify';
import {history} from '../../../../../store';
import PageTitle from '../../../../common/page-title';
import RequiredTextarea from '../../../../common/form/elements/required-textarea';
import RequiredInput from '../../../../common/form/elements/required-input';
import {getEmailLog, updateEmailLog} from '../../../../../actions/logs';
import Button from '../../../../common/button';
import BackLink from '../../../../common/back-link';

class EditEmail extends Component {
  handleSave = (send) => {
    const {dispatch, formData} = this.props;
    dispatch(updateEmailLog(this.id, formData, send)).then(() => {
      toast.success(send ? 'Email has been successfully saved and resent' : 'Email has been successfully saved');
      history.push('/admin/email-logs');
    });
  };

  constructor(props) {
    super(props);
    this.id = this.props.match.params.id;
  }

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getEmailLog(this.id));
  }

  render() {
    return (
      <Container fluid className="notifications">
        <BackLink href="/admin/email-logs"/>
        <PageTitle>Email notification log</PageTitle>
        <Form model="deep.edit_email_notifications" onSubmit={() => this.handleSave(false)}>
          <RequiredInput model=".rcpt" label="To"/>
          <RequiredInput model=".subject" label="Subject"/>
          <RequiredTextarea model=".body" label="Email body" rows={5} disabled/>
          <div className="float-end">
            <Button onClick={() => this.handleSave(true)} inline>
              Save & resend
            </Button>
            <Button submit inline>Save</Button>
          </div>
        </Form>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.edit_email_notifications,
});

export default connect(mapStateToProps)(EditEmail);
